<template>
  <div class="d-flex w-100 rel-wrap">
    <div class="col-lg-3 rel-left">
      <Forms ref="frmSearch"
             title="Relação de LVs e Vistorias"
             :showHelp="false"
             :showClearButton="true"
             :showSearchButton="true"
             :showNewButton="false"
             :ShowFooterImbo="true"
             messageTipFooter="Busque por obra ou empreendimento para gerar o relatório"
             style="font-family: 'Segoe UI'"
             v-on:Clear="limpar"
             v-on:Search="gerar">
        <div style="width: 100%;">
          <label class="labelsearch">Obra</label>
          <autocomplete-z ref="obraRHTypeahead"
              placeholder="Digite ou clique pra escolher a Obra"
              iconClass="fas fa-hard-hat"
              :serializer="(obra) => obra.localizacao ? `${obra.referencia} — ${obra.localizacao}` : obra.referencia"
              :debounceLength="1"
              :formField="form.obraid"
              v-on:search="onSearchObra"
              :ShowCode="false"
              :showOnFocus="true"
              :maxMatches="50"
              v-on:changeCode="onChangeCodeObra"
              v-on:hit="onHitObra" />
        </div>

        <div style="width: 100%;" class="mt-3">
          <label class="labelsearch">Empreendimento</label>
          <autocomplete ref="empreendimentoTypeahead"
              v-model="empreendimentoBusca"
              placeholder="Digite ou clique pra escolher o Empreendimento"
              :serializer="(e) => e"
              :data="empreendimentosData"
              :showOnFocus="true"
              :maxMatches="50"
              inputClass="autocompleteClass"
              @keyup.enter="gerar" />
        </div>

        <div class="export-excel-wrap d-flex justify-content-center mt-3">
          <button class="btn-exportar-excel w-75" :disabled="!linhas.length" @click="exportarExcel">
            <i class="fas fa-file-excel mr-2"></i>Exportar Excel
          </button>
        </div>
      </Forms>
    </div>

    <div class="col-lg-9 d-flex flex-column">
      <div v-if="!gerado" class="text-muted text-center p-5 border rounded bg-light">
        Selecione obra ou empreendimento à esquerda e clique em <b>Buscar</b>.
      </div>

      <div v-else-if="!linhas.length" class="text-muted text-center p-5 border rounded bg-light">
        Nenhuma LV vinculada a casa nesta seleção.
        <br><small>Use "Unir com SAP" na consulta de QMA para vincular as LVs às casas.</small>
      </div>

      <template v-else>
        <div class="card rel-card mb-2">
          <div class="card-body p-2 d-flex flex-column rel-card-body">
        <div class="table-responsive rel-tabela-scroll">
          <table class="tbl-plan">
            <thead>
              <tr><th class="titulo" colspan="13">PLANILHA DE LVS E VISTORIAS - OBRAS</th></tr>
              <tr>
                <td class="lbl" colspan="3">DATA ATUALIZAÇÃO:</td>
                <td class="val" colspan="10">{{ dataAtualizacao }}</td>
              </tr>
              <tr>
                <td class="lbl" colspan="3">EMPREENDIMENTO:</td>
                <td class="val" colspan="10">{{ empreendimentoLabel }}</td>
              </tr>
              <tr class="grupo">
                <th rowspan="2">ITEM</th>
                <th rowspan="2">QD</th>
                <th rowspan="2">LOTE</th>
                <th rowspan="2">NOME CLIENTE</th>
                <th colspan="2" class="grp-lv">LV</th>
                <th colspan="3" class="grp-v1">1ª VISTORIA CLIENTE</th>
                <th colspan="3" class="grp-v2">2ª VISTORIA (EM CASO DE REPROVA)</th>
                <th rowspan="2">OBSERVAÇÃO</th>
              </tr>
              <tr class="grupo">
                <th class="grp-lv">DATA</th><th class="grp-lv">RESPONSÁVEL</th>
                <th class="grp-v1">DATA 1ª VISTORIA</th><th class="grp-v1">RESPONSÁVEL</th><th class="grp-v1">STATUS</th>
                <th class="grp-v2">DATA 2ª VISTORIA</th><th class="grp-v2">RESPONSÁVEL</th><th class="grp-v2">STATUS</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(l, i) in linhasPagina" :key="i">
                <td>{{ (paginaAtual - 1) * porPagina + i + 1 }}</td>
                <td>{{ l.quadra }}</td>
                <td>{{ l.unidade }}</td>
                <td class="txt-left" :title="l.cliente">{{ l.cliente }}</td>
                <td class="grp-lv">{{ fmtData(l.lvData) }}</td>
                <td class="grp-lv" :title="l.lvResponsavel">{{ l.lvResponsavel }}</td>
                <td class="grp-v1">{{ fmtData(l.vist1Data) }}</td>
                <td class="grp-v1" :title="l.vist1Responsavel">{{ l.vist1Responsavel }}</td>
                <td class="grp-v1" :class="classeStatus(l.vist1Status)">{{ l.vist1Status }}</td>
                <td class="grp-v2">{{ fmtData(l.vist2Data) }}</td>
                <td class="grp-v2" :title="l.vist2Responsavel">{{ l.vist2Responsavel }}</td>
                <td class="grp-v2" :class="classeStatus(l.vist2Status)">{{ l.vist2Status }}</td>
                <td class="txt-left" :title="l.observacao">{{ l.observacao }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-if="linhas.length > porPagina" class="rel-pager pt-2">
          <b-pagination v-model="paginaAtual" :total-rows="linhas.length" :per-page="porPagina"
                        size="sm" align="left" class="mb-0" />
        </div>
          </div>
        </div>

        <!-- Resumo em card próprio, fluxo normal da página (rola junto, sem position:fixed —
             era a causa da instabilidade: JS media pixel pra tentar acompanhar o card da
             tabela e sempre ficava alguns px fora de sincronia entre páginas/tamanhos de tela). -->
        <div class="card rel-resumo">
          <div class="card-body p-2 table-responsive">
            <table class="tbl-plan">
              <tbody>
                <tr class="q-head">
                  <td colspan="3" class="grp-lv">QUANTIDADE LV</td>
                  <td colspan="3" class="grp-v1">QUANTIDADE 1ª VISTORIA</td>
                  <td colspan="3" class="grp-v2">QUANTIDADE 2ª VISTORIA</td>
                </tr>
                <tr>
                  <td class="q-lbl">TOTAL PJ</td><td>{{ resumo.total }}</td><td>{{ pct(resumo.total, resumo.total) }}</td>
                  <td class="q-lbl">TOTAL PJ</td><td>{{ resumo.total }}</td><td>{{ pct(resumo.total, resumo.total) }}</td>
                  <td class="q-lbl">TOTAL 2ª VISTORIA</td><td>{{ resumo.total2 }}</td><td></td>
                </tr>
                <tr>
                  <td class="q-lbl">REALIZADO</td><td>{{ resumo.total }}</td><td>{{ pct(resumo.total, resumo.total) }}</td>
                  <td class="q-lbl st-aprov">APROVADO</td><td>{{ resumo.v1Ap }}</td><td>{{ pct(resumo.v1Ap, resumo.total) }}</td>
                  <td class="q-lbl st-aprov">APROVADO</td><td>{{ resumo.v2Ap }}</td><td>{{ pct(resumo.v2Ap, resumo.total2) }}</td>
                </tr>
                <tr>
                  <td colspan="3"></td>
                  <td class="q-lbl st-reprov">NÃO APROVADO</td><td>{{ resumo.v1Re }}</td><td>{{ pct(resumo.v1Re, resumo.total) }}</td>
                  <td class="q-lbl st-reprov">NÃO APROVADO</td><td>{{ resumo.v2Re }}</td><td>{{ pct(resumo.v2Re, resumo.total2) }}</td>
                </tr>
                <tr class="q-total">
                  <td colspan="3"></td>
                  <td class="q-lbl">TOTAL VISTORIAS REALIZADAS</td><td>{{ resumo.v1Real }}</td><td>{{ pct(resumo.v1Real, resumo.total) }}</td>
                  <td class="q-lbl">TOTAL VISTORIAS REALIZADAS</td><td>{{ resumo.v2Real }}</td><td>{{ pct(resumo.v2Real, resumo.total2) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpensezpag/mixins/ExpenseMixin'
import AutocompleteZ from '@/components/forms/AutocompleteZ.vue'
import ObraVinculoSapRepository from '@/shared/http/repositories/business/obraVinculoSap'
import { toast, loading } from '@/shared/utils/UIHelper'
import { saveAs } from 'file-saver'

// CSS embutido no .xls exportado (as classes do <style scoped> não vão no outerHTML).
const EXPORT_CSS = `
table{border-collapse:collapse;font-family:Calibri,Arial,sans-serif;font-size:11px;}
th,td{border:1px solid #999;padding:3px 5px;text-align:center;}
.titulo{background:#548235;color:#fff;font-size:14px;font-weight:bold;}
.lbl{text-align:right;font-weight:bold;background:#f2f2f2;}
.val{text-align:left;font-weight:bold;}
.grupo th{background:#E2EFDA;font-weight:bold;}
.q-head td{background:#E2EFDA;font-weight:bold;}
.q-head td.grp-lv{background:#BDD7EE;}
.q-head td.grp-v1{background:#C6E0B4;}
.q-head td.grp-v2{background:#F8CBAD;}
.q-lbl{text-align:left;font-weight:bold;}
.q-total td{font-weight:bold;background:#f2f2f2;}
.txt-left{text-align:left;}
th.grp-lv{background:#BDD7EE;}
th.grp-v1{background:#C6E0B4;}
th.grp-v2{background:#F8CBAD;}
td.grp-lv{background:#DDEBF7;}
td.grp-v1{background:#E2EFDA;}
td.grp-v2{background:#FCE4D6;}
td.st-aprov{background:#C6EFCE;color:#006100;font-weight:bold;}
td.st-reprov{background:#FFC7CE;color:#9C0006;font-weight:bold;}
`

export default {
  name: 'relatorioLvVistorias',
  components: { AutocompleteZ },
  mixins: [ActionsForm, ExpenseMixin],
  data () {
    return {
      empreendimentoBusca: '',
      empreendimentosData: [],
      form: {
        obraid: { value: null, options: [], required: false, state: null, code: null }
      },
      linhas: [],
      empreendimento: '',
      dataAtualizacao: '',
      gerado: false,
      paginaAtual: 1,
      // Fixo — a área da tabela (.rel-tabela-scroll) tem altura fixa em CSS (flex:1 dentro de
      // .rel-card-body) e rola por dentro se sobrar linha. Nunca recalculado por pixel: era
      // isso que fazia o card e a paginação mudarem de tamanho/lugar entre páginas ou telas.
      porPagina: 15
    }
  },
  mounted () {
    this.carregarObrasIniciais()
    this.carregarEmpreendimentosIniciais()
  },
  computed: {
    // "L1.0007/21 — SP-ZR6 - JAU ..." : só a referência (o código) não diz nada pra quem lê a
    // planilha. Quando o back não achou nome (empreendimento === referência) mostra só o código.
    empreendimentoLabel () {
      // Busca por empreendimento traz mais de uma obra: aí a referência da primeira linha não
      // representa o conjunto e o header fica só com o nome do empreendimento.
      const refs = new Set(this.linhas.map(l => (l.obraReferencia || '').trim()).filter(Boolean))
      const ref = refs.size === 1 ? Array.from(refs)[0] : ''
      const nome = (this.empreendimento || '').trim()
      if (!ref) return nome
      if (!nome || nome === ref) return ref
      return `${ref} — ${nome}`
    },
    linhasPagina () {
      const ini = (this.paginaAtual - 1) * this.porPagina
      return this.linhas.slice(ini, ini + this.porPagina)
    },
    resumo () {
      const l = this.linhas
      const cont = pred => l.filter(pred).length
      const total = l.length
      const v1Ap = cont(x => x.vist1Status === 'APROVADO')
      const v1Re = cont(x => x.vist1Status === 'NAO APROVADO')
      const l2 = l.filter(x => x.vist2Status)
      const total2 = l2.length
      const v2Ap = l2.filter(x => x.vist2Status === 'APROVADO').length
      const v2Re = l2.filter(x => x.vist2Status === 'NAO APROVADO').length
      return {
        total,
        v1Ap,
        v1Re,
        v1Real: v1Ap + v1Re,
        total2,
        v2Ap,
        v2Re,
        v2Real: v2Ap + v2Re
      }
    }
  },
  methods: {
    // Pré-carrega as obras candidatas (as que têm QMA) pra aparecer a lista já no clique/foco,
    // sem precisar digitar antes (showOnFocus).
    carregarObrasIniciais () {
      ObraVinculoSapRepository.GetObrasParaRelatorioLvs('')
        .then(response => {
          if (response.data.code > 0) this.$refs.obraRHTypeahead.data = response.data.data
        })
        .catch(err => { console.log(err) })
    },
    // Pré-carrega os empreendimentos das casas já unidas (lista pequena, filtro fica 100% no cliente).
    carregarEmpreendimentosIniciais () {
      ObraVinculoSapRepository.GetEmpreendimentosParaRelatorioLvs()
        .then(response => {
          if (response.data.code > 0) this.empreendimentosData = response.data.data.map(e => e.empreendimento)
        })
        .catch(err => { console.log(err) })
    },
    onSearchObra (value) {
      if (!value || value.trim().length < 1) return
      ObraVinculoSapRepository.GetObrasParaRelatorioLvs(value)
        .then(response => {
          if (response.data.code > 0) this.$refs.obraRHTypeahead.data = response.data.data
        })
        .catch(err => { console.log(err) })
    },
    onChangeCodeObra (value) {
      if (value) this.onSearchObra(value)
    },
    // Ao limpar o campo (seleção apagada manualmente), o AutocompleteZ zera o data interno
    // e emite hit(null) — recarrega a lista cheia pra reabrir no próximo foco.
    onHitObra (value) {
      if (!value) this.carregarObrasIniciais()
    },
    gerar () {
      let req = null
      const textoObra = ((this.$refs.obraRHTypeahead && this.$refs.obraRHTypeahead.query) || '').trim()
      if (this.form.obraid.value) {
        req = ObraVinculoSapRepository.GetRelatorioLvs(this.form.obraid.value)
      } else if (textoObra) {
        // Código digitado sem fechar em 1 item do autocomplete (ex.: "L1.0029" incompleto) —
        // busca todas as casas cujo código contém o texto.
        req = ObraVinculoSapRepository.GetRelatorioLvsPorTextoObra(textoObra)
      } else if (this.empreendimentoBusca && this.empreendimentoBusca.trim()) {
        req = ObraVinculoSapRepository.GetRelatorioLvsPorEmpreendimento(this.empreendimentoBusca.trim())
      }

      if (!req) { toast.error('Informe a obra ou o empreendimento.'); return }

      loading.push()
      req
        .then(response => {
          const dados = (response.data && response.data.data) ? response.data.data : []
          this.linhas = dados
          this.paginaAtual = 1
          this.empreendimento = dados.length
            ? (dados[0].empreendimento || '')
            : (this.empreendimentoBusca || '')
          this.dataAtualizacao = this.fmtData(new Date())
          this.gerado = true
          if (!dados.length) toast.info('Nenhuma LV vinculada a casa nesta seleção.')
        })
        .catch(err => { console.log(err); toast.error('Erro ao gerar o relatório.') })
        .finally(() => loading.close())
    },
    limpar () {
      if (this.$refs.obraRHTypeahead) this.$refs.obraRHTypeahead.clear()
      this.form.obraid.value = null
      this.empreendimentoBusca = ''
      this.linhas = []
      this.empreendimento = ''
      this.gerado = false
      this.paginaAtual = 1
    },
    fmtData (v) {
      if (!v) return ''
      const d = new Date(v)
      if (isNaN(d.getTime())) return ''
      const p = n => String(n).padStart(2, '0')
      return `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()}`
    },
    pct (n, d) {
      if (!d) return ''
      return (n / d * 100).toFixed(1).replace('.', ',') + '%'
    },
    classeStatus (status) {
      if (status === 'APROVADO') return 'st-aprov'
      if (status === 'NAO APROVADO') return 'st-reprov'
      return ''
    },
    // O Excel abre este .xls como HTML e NAO resolve cascata de CSS: numa celula
    // com duas classes (ex. "grp-v1 st-aprov") ele fica com a cor da secao e
    // ignora a do status, que e o que fazia o STATUS sair sem cor na planilha.
    // No browser funciona porque td.st-aprov vem depois no arquivo e ganha por
    // ordem -- garantia que o Excel nao da. Por isso a cor do status vai inline
    // no export, com os mesmos hex da tela.
    styleStatus (status) {
      if (status === 'APROVADO') return 'background:#C6EFCE;color:#006100;font-weight:bold;'
      if (status === 'NAO APROVADO') return 'background:#FFC7CE;color:#9C0006;font-weight:bold;'
      return ''
    },
    // Monta a planilha inteira (header + TODAS as linhas + rodapé) para o .xls,
    // independente da paginação da tela.
    buildExportHtml () {
      const r = this.resumo
      const linha = (l, i) => `<tr>
        <td>${i + 1}</td><td>${l.quadra || ''}</td><td>${l.unidade || ''}</td>
        <td class="txt-left">${l.cliente || ''}</td>
        <td class="grp-lv">${this.fmtData(l.lvData)}</td><td class="grp-lv">${l.lvResponsavel || ''}</td>
        <td class="grp-v1">${this.fmtData(l.vist1Data)}</td><td class="grp-v1">${l.vist1Responsavel || ''}</td>
        <td class="grp-v1 ${this.classeStatus(l.vist1Status)}" style="${this.styleStatus(l.vist1Status)}">${l.vist1Status || ''}</td>
        <td class="grp-v2">${this.fmtData(l.vist2Data)}</td><td class="grp-v2">${l.vist2Responsavel || ''}</td>
        <td class="grp-v2 ${this.classeStatus(l.vist2Status)}" style="${this.styleStatus(l.vist2Status)}">${l.vist2Status || ''}</td>
        <td class="txt-left">${l.observacao || ''}</td></tr>`
      const dados = this.linhas.map(linha).join('')
      return `<table>
        <tr><td class="titulo" colspan="13">PLANILHA DE LVS E VISTORIAS - OBRAS</td></tr>
        <tr><td class="lbl" colspan="3">DATA ATUALIZAÇÃO:</td><td class="val" colspan="10">${this.dataAtualizacao}</td></tr>
        <tr><td class="lbl" colspan="3">EMPREENDIMENTO:</td><td class="val" colspan="10">${this.empreendimentoLabel}</td></tr>
        <tr class="grupo"><th>ITEM</th><th>QD</th><th>LOTE</th><th>NOME CLIENTE</th><th colspan="2" class="grp-lv">LV</th><th colspan="3" class="grp-v1">1ª VISTORIA CLIENTE</th><th colspan="3" class="grp-v2">2ª VISTORIA (EM CASO DE REPROVA)</th><th>OBSERVAÇÃO</th></tr>
        <tr class="grupo"><th></th><th></th><th></th><th></th><th class="grp-lv">DATA</th><th class="grp-lv">RESPONSÁVEL</th><th class="grp-v1">DATA 1ª VISTORIA</th><th class="grp-v1">RESPONSÁVEL</th><th class="grp-v1">STATUS</th><th class="grp-v2">DATA 2ª VISTORIA</th><th class="grp-v2">RESPONSÁVEL</th><th class="grp-v2">STATUS</th><th></th></tr>
        ${dados}
        <tr><td colspan="13"></td></tr>
        <tr class="q-head"><td colspan="4"></td><td colspan="2" class="grp-lv">QUANTIDADE LV</td><td></td><td colspan="2" class="grp-v1">QUANTIDADE 1ª VISTORIA</td><td></td><td colspan="2" class="grp-v2">QUANTIDADE 2ª VISTORIA</td><td></td></tr>
        <tr><td colspan="4"></td><td class="q-lbl">TOTAL PJ</td><td>${r.total}</td><td>${this.pct(r.total, r.total)}</td><td class="q-lbl">TOTAL PJ</td><td>${r.total}</td><td>${this.pct(r.total, r.total)}</td><td class="q-lbl">TOTAL 2ª VISTORIA</td><td>${r.total2}</td><td></td></tr>
        <tr><td colspan="4"></td><td class="q-lbl">REALIZADO</td><td>${r.total}</td><td>${this.pct(r.total, r.total)}</td><td class="q-lbl st-aprov" style="text-align:left;background:#C6EFCE;color:#006100;font-weight:bold;">APROVADO</td><td>${r.v1Ap}</td><td>${this.pct(r.v1Ap, r.total)}</td><td class="q-lbl st-aprov" style="text-align:left;background:#C6EFCE;color:#006100;font-weight:bold;">APROVADO</td><td>${r.v2Ap}</td><td>${this.pct(r.v2Ap, r.total2)}</td></tr>
        <tr><td colspan="7"></td><td class="q-lbl st-reprov" style="text-align:left;background:#FFC7CE;color:#9C0006;font-weight:bold;">NÃO APROVADO</td><td>${r.v1Re}</td><td>${this.pct(r.v1Re, r.total)}</td><td class="q-lbl st-reprov" style="text-align:left;background:#FFC7CE;color:#9C0006;font-weight:bold;">NÃO APROVADO</td><td>${r.v2Re}</td><td>${this.pct(r.v2Re, r.total2)}</td></tr>
        <tr class="q-total"><td colspan="7"></td><td class="q-lbl">TOTAL VISTORIAS REALIZADAS</td><td>${r.v1Real}</td><td>${this.pct(r.v1Real, r.total)}</td><td class="q-lbl">TOTAL VISTORIAS REALIZADAS</td><td>${r.v2Real}</td><td>${this.pct(r.v2Real, r.total2)}</td></tr>
      </table>`
    },
    exportarExcel () {
      if (!this.linhas.length) return
      const html = `<html xmlns:x="urn:schemas-microsoft-com:office:excel"><head><meta charset="utf-8"><style>${EXPORT_CSS}</style></head><body>${this.buildExportHtml()}</body></html>`
      const blob = new Blob(['﻿', html], { type: 'application/vnd.ms-excel' })
      const nome = `Relacao_LV_Vistorias_${(this.empreendimentoLabel || 'obra').replace(/[^a-z0-9]+/gi, '_')}.xls`
      saveAs(blob, nome)
    }
  }
}
</script>

<style scoped>
.labelsearch { font-weight: 700; color: #666; font-size: 14px; margin-bottom: 5px; }
.rel-wrap { min-height: calc(100vh - 185px); align-items: stretch; }
.rel-left { display: flex; flex-direction: column; }
.rel-left > * { flex: 0 0 auto; }
.export-excel-wrap { margin-top: 1rem; }
/* Dropdown do autocomplete de Empreendimento é position:absolute com max-height 350px
   (VueTypeaheadBootstrap, global) — sem isso ele cobre o Excel + Buscar/Limpar abaixo
   enquanto o campo tá focado. Encurtando só nesta tela. */
.rel-left >>> .vbt-autcomplete-list { max-height: 160px !important; }
/* Excel colado no Buscar (grupo visual) — o footer BUSCAR/LIMPAR do Forms.vue vem com
   mt-5 fixo (component genérico, não dá pra mudar geral); encurtando só aqui. */
.rel-left >>> .mt-5.mb-5 { margin-top: 0.5rem !important; }
.btn-exportar-excel {
  background-color: #008148;
  border-radius: 5px;
  color: white;
  height: 35px;
  border: 1px solid #CED4DA;
}
.btn-exportar-excel:hover:not(:disabled) { background-color: rgb(3 172 97); }
.btn-exportar-excel:disabled { background-color: #a1a1a1; border-color: #a1a1a1; cursor: default; }
.tbl-plan { width: 100%; border-collapse: collapse; font-size: 11px; }
.tbl-plan th, .tbl-plan td { border: 1px solid #999; padding: 3px 5px; text-align: center; }
/* TODA celula do corpo em uma linha só. Sem isso a altura variava (medi 26, 45 e 65px na
   mesma página) e a conta de quantas linhas cabem errava, fazendo a tabela ora sobrar espaço
   ora passar por baixo do rodapé fixo. Os campos que estouram são os nomes de RESPONSÁVEL e
   o cliente; o texto inteiro continua acessível no title (e vai completo no Excel). */
.tbl-plan tbody td {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 150px;
}
.tbl-plan td.txt-left { text-align: left; max-width: 200px; }
.tbl-plan td:nth-child(2), .tbl-plan td:nth-child(3) { white-space: nowrap; }
.tbl-plan .titulo { background: #548235; color: #fff; font-size: 14px; padding: 6px; }
.tbl-plan td.lbl { text-align: right; font-weight: 700; background: #f2f2f2; }
.tbl-plan td.val { text-align: left; font-weight: 700; }
.tbl-plan tr.grupo th { background: #E2EFDA; font-weight: 700; }
/* Cor por seção: LV=azul, 1ª vistoria=verde, 2ª vistoria=laranja. Cabeçalho em tom forte,
   corpo em tom claro — na coluna STATUS o verde/vermelho de aprovado/reprovado (st-aprov/
   st-reprov, declarados mais abaixo) tem que vencer o tom da seção, por isso essas regras
   ficam ANTES no arquivo (mesma especificidade, quem vem depois no CSS ganha). */
.tbl-plan th.grp-lv { background: #BDD7EE; }
.tbl-plan th.grp-v1 { background: #C6E0B4; }
.tbl-plan th.grp-v2 { background: #F8CBAD; }
.tbl-plan td.grp-lv { background: #DDEBF7; }
.tbl-plan td.grp-v1 { background: #E2EFDA; }
.tbl-plan td.grp-v2 { background: #FCE4D6; }
.tbl-plan tr.q-head td { background: #E2EFDA; font-weight: 700; }
/* Título do quadro resumo na mesma cor forte do cabeçalho de cima (th.grp-*) — precisa de
   mais uma classe pra vencer a especificidade da regra genérica ".q-head td" acima. */
.tbl-plan tr.q-head td.grp-lv { background: #BDD7EE; }
.tbl-plan tr.q-head td.grp-v1 { background: #C6E0B4; }
.tbl-plan tr.q-head td.grp-v2 { background: #F8CBAD; }
.tbl-plan td.q-lbl { text-align: left; font-weight: 700; }
.tbl-plan tr.q-total td { font-weight: 700; background: #f2f2f2; }
.tbl-plan td.st-aprov { background: #C6EFCE; color: #006100; font-weight: 600; }
.tbl-plan td.st-reprov { background: #FFC7CE; color: #9C0006; font-weight: 600; }
.rel-card { border: 1px solid #ccc; }
/* Altura FIXA do card (não depende de quantas linhas a página atual tem) — a página com menos
   linhas (ex: última) só deixa espaço vazio embaixo, nunca encolhe o card. É o que fixa o
   card sempre no tamanho da página "cheia" (a maior), em vez de variar por página. flex:1 na
   área de rolagem some o espaço que falta; a paginação (.rel-pager) é item de flex normal,
   sempre visível no rodapé do PRÓPRIO card — não precisa mais de JS medindo pixel nem de
   position:fixed pra "acompanhar" o card. */
.rel-card-body {
  height: 60vh;
  min-height: 320px;
  max-height: 640px;
}
.rel-tabela-scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
}
.rel-pager {
  flex-shrink: 0;
  border-top: 1px solid #e0e0e0;
}
/* Resumo em fluxo normal da página (position:fixed removido — era a causa da instabilidade:
   JS tentava sincronizar left/width/bottom com o card da tabela via getBoundingClientRect()
   a cada busca/página/resize, e qualquer diferença de 1 frame deixava o bloco fora de lugar
   ou sobrepondo a paginação). Agora é só outro card, rola com a página como qualquer outro. */
.rel-resumo { margin: 0; }

/* Tablet (<992px, breakpoint padrão do Bootstrap pro col-lg-*): busca empilha acima da
   tabela (herdado do grid), reduz fonte/padding pra caber sem precisar rolar demais na
   horizontal, e encurta a altura fixa do card pra sobrar mais espaço de tela. */
@media (max-width: 991.98px) {
  .rel-card-body { height: 50vh; min-height: 260px; }
  .tbl-plan { font-size: 10px; }
  .tbl-plan th, .tbl-plan td { padding: 2px 4px; }
  .tbl-plan tbody td { max-width: 110px; }
  .tbl-plan td.txt-left { max-width: 140px; }
}
</style>



// WEBPACK FOOTER //
// src/views/private/qma/qmaReport/relatorioLvVistorias/relatorioLvVistorias.vue